import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Form, Icon, Input, Button,
} from 'antd';
import { Link } from 'react-router-dom';
import { resetPasswordRequest } from '../redux/actions/account_actions/reset_password_actions';
import { validation_rules } from '../../../shared/validation_rules';
import { WelcomeTitle } from './WelcomeTitle';

const mapStateToProps = (state) => {
    const { isResetPassword, hasResetPassword } = state.App.Reset_password_form;
    return { isResetPassword, hasResetPassword };
}; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class ResetPasswordForm extends Component {
  state = {
      new_password: '',
      confirm_new_password: '',
      firstPasswordVisibility: false,
      secondPasswordVisibility: false,
  };

  handleChange = (name, value) => this.setState({ [name]: value });

  showFirstPassword = () => this.setState({ firstPasswordVisibility: !this.state.firstPasswordVisibility });

  showSecondPassword = () => this.setState({ secondPasswordVisibility: !this.state.secondPasswordVisibility });

  resetPassword = (event) => {
      event.preventDefault();
      const token = this.props.location.search.substr(7); const
          { new_password } = this.state;
      this.props.dispatch(resetPasswordRequest(token, new_password));
  };

  render() {
      const {
          new_password, confirm_new_password, firstPasswordVisibility, secondPasswordVisibility,
      } = this.state;
      const { isResetPassword, hasResetPassword } = this.props;
      if (isResetPassword) return null;
      return !hasResetPassword
          ? (
              <div className="account forgotPassword">
                  <div className="account__wrapper">
                      <div className="account__card">
                          <WelcomeTitle>
                              <h4 className="account__subhead subhead">Please enter a new password. It must be at least 6-8 characters and must contain at least 1 number and one special character</h4>
                          </WelcomeTitle>
                          <Form onSubmit={this.resetPassword} className="login-form">
                              <FormItem label="Password">
                                  <Input
                                      value={new_password}
                                      type={firstPasswordVisibility ? 'text' : 'password'}
                                      maxLength={20}
                                      prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      suffix={<Icon type="eye" onMouseDown={this.showFirstPassword} onMouseUp={this.showFirstPassword} style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      placeholder="Enter new password"
                                      onChange={event => this.handleChange('new_password', event.target.value)}
                                  />
                              </FormItem>
                              <span className="validationError">{new_password && validation_rules.password(new_password)}</span>
                              <FormItem label="Confirm Password">
                                  <Input
                                      value={confirm_new_password}
                                      type={secondPasswordVisibility ? 'text' : 'password'}
                                      maxLength={20}
                                      prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      suffix={<Icon type="eye" onMouseDown={this.showSecondPassword} onMouseUp={this.showSecondPassword} style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      placeholder="Confirm new password"
                                      onChange={event => this.handleChange('confirm_new_password', event.target.value)}
                                  />
                              </FormItem>
                              <span className="validationError">{confirm_new_password && validation_rules.passwordMatching(new_password, confirm_new_password)}</span>
                              <FormItem className="btnWrapper">
                                  <Button
                                      type="primary"
                                      loading={isResetPassword}
                                      style={{ width: '100%' }}
                                      disabled={!(!validation_rules.password(new_password) && !validation_rules.passwordMatching(new_password, confirm_new_password) && new_password && confirm_new_password)}
                                      htmlType="submit"
                                  >
                                      Reset Password
                                  </Button>
                              </FormItem>
                          </Form>
                      </div>
                  </div>
              </div>
          )
          : (
              <div className="account forgotPassword">
                  <div className="account__wrapper">
                      <div className="account__card">
                          <WelcomeTitle />
                          <p><strong>Thank you.</strong></p>
                          <p>You have been successfully reset your password.</p>
                          <p><Link to="/login">Click here to Login</Link></p>
                      </div>
                  </div>
              </div>
          );
  }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/ResetPasswordForm.js